import { useState } from "react";
import useAutoActions from "../../hooks/use-auto-actions";
import useTenantAutoActions from "../../hooks/use-tenant-auto-actions";
import Action from "./Action";
import AutomatisationCard from "./AutomatisationCard";
import { AutoActionType } from "../../utils/constants/autoActions";
import { TenantLeaseType } from "../../utils/constants/tenants";

export default function ActionList({ tenant }) {
  const { autoActions } = useAutoActions();
  const {
    tenantAutoActions,
    createTenantAutoAction,
    deleteTenantAutoAction,
    updateTenantAutoAction,
    refresh,
  } = useTenantAutoActions(tenant.id);

  const [isToggling, setIsToggling] = useState(false);

  async function onToggle(e, action, tenantAutoAction) {
    setIsToggling(true);
    try {
      if (e.target.checked) {
        await createTenantAutoAction({
          nom_auto_action: action.static_id,
        });
      } else {
        await deleteTenantAutoAction(tenantAutoAction?.id);
      }
      await refresh();
    } catch (e) {
      console.error(e);
    } finally {
      setIsToggling(false);
    }
  }

  return (
    <AutomatisationCard>
      {autoActions?.map((action, i) => {
        const tenantAutoAction = tenantAutoActions.find(
          (filtered) => filtered.nom_auto_action === action.static_id,
        );
        let checked = !!tenantAutoAction;
        if (
          [
            AutoActionType.RESILIATION_BAIL,
            AutoActionType.REVISION_LOYER,
          ].includes(action.static_id) &&
          [TenantLeaseType.MOBILITE, TenantLeaseType.LCD].includes(
            tenant.lease_type,
          )
        ) {
          return null;
        }
        if (
          action.static_id === AutoActionType.ATTESTATION_CHAUFFAGE &&
          !TenantLeaseType.isHabitation(tenant.lease_type)
        ) {
          return null;
        }
        return (
          <Action
            action={action}
            checked={checked}
            autoActionAssociation={tenantAutoAction}
            onUpdate={updateTenantAutoAction}
            onToggle={onToggle}
            disabled={isToggling}
            key={i}
          />
        );
      })}
    </AutomatisationCard>
  );
}
